unit SystemGeneralLedgerAccountsSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmGeneralLedgerAccounts = class(TForm)
    WebPanel1: TPanel;
    WebDBCheckBox1: TDBCheckBox;
    WebDBCheckBox2: TDBCheckBox;
    WebDBCheckBox3: TDBCheckBox;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebButton3: TButton;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    wcGLCodes: TXDataWebClient;
    wdsGLCodes: TXDataWebDataSet;
    wdsGLCodesGLCODE: TStringField;
    wdsGLCodesGLDESCRIPTION: TStringField;
    wdsGLCodesSUSPENDED: TBooleanField;
    wdsGLCodesbankaccount: TBooleanField;
    wdsGLCodesbankcard: TBooleanField;
    dsGLCodes: TDataSource;
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iState : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmGeneralLedgerAccounts: TfrmGeneralLedgerAccounts;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common;

procedure TfrmGeneralLedgerAccounts.WebFormShow(Sender: TObject);

  procedure OnResultGLCodes(Response : TXDataClientResponse);
    begin
      wdsGLCodes.Close;
      wdsGLCodes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsGLCodes.Open;
    end;
begin
  wcGLCodes.RawInvoke('IstfmsSystemService.Get_GLCodes_View',[0,'*'],@OnResultGLCodes);
end;

procedure TfrmGeneralLedgerAccounts.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  WebDBCheckBox2 := TDBCheckBox.Create(Self);
  WebDBCheckBox3 := TDBCheckBox.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebButton3 := TButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  wcGLCodes := TXDataWebClient.Create(Self);
  wdsGLCodes := TXDataWebDataSet.Create(Self);
  wdsGLCodesGLCODE := TStringField.Create(Self);
  wdsGLCodesGLDESCRIPTION := TStringField.Create(Self);
  wdsGLCodesSUSPENDED := TBooleanField.Create(Self);
  wdsGLCodesbankaccount := TBooleanField.Create(Self);
  wdsGLCodesbankcard := TBooleanField.Create(Self);
  dsGLCodes := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  WebDBCheckBox2.BeforeLoadDFMValues;
  WebDBCheckBox3.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  wcGLCodes.BeforeLoadDFMValues;
  wdsGLCodes.BeforeLoadDFMValues;
  wdsGLCodesGLCODE.BeforeLoadDFMValues;
  wdsGLCodesGLDESCRIPTION.BeforeLoadDFMValues;
  wdsGLCodesSUSPENDED.BeforeLoadDFMValues;
  wdsGLCodesbankaccount.BeforeLoadDFMValues;
  wdsGLCodesbankcard.BeforeLoadDFMValues;
  dsGLCodes.BeforeLoadDFMValues;
  try
    Name := 'frmGeneralLedgerAccounts';
    Width := 640;
    Height := 382;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 382;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 120;
    WebLabel1.Top := 112;
    WebLabel1.Width := 96;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'GL Account Code:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 88;
    WebLabel2.Top := 139;
    WebLabel2.Width := 128;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'GL Account Description:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.SetParentComponent(WebPanel1);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 240;
    WebDBCheckBox1.Top := 200;
    WebDBCheckBox1.Width := 113;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := 'Suspended';
    WebDBCheckBox1.ChildOrder := 2;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.DataField := 'SUSPENDED';
    WebDBCheckBox1.DataSource := dsGLCodes;
    WebDBCheckBox2.SetParentComponent(WebPanel1);
    WebDBCheckBox2.Name := 'WebDBCheckBox2';
    WebDBCheckBox2.Left := 240;
    WebDBCheckBox2.Top := 228;
    WebDBCheckBox2.Width := 113;
    WebDBCheckBox2.Height := 22;
    WebDBCheckBox2.Caption := 'Bank Accounts';
    WebDBCheckBox2.ChildOrder := 3;
    WebDBCheckBox2.HeightPercent := 100.000000000000000000;
    WebDBCheckBox2.WidthPercent := 100.000000000000000000;
    WebDBCheckBox2.DataField := 'bankaccount';
    WebDBCheckBox2.DataSource := dsGLCodes;
    WebDBCheckBox3.SetParentComponent(WebPanel1);
    WebDBCheckBox3.Name := 'WebDBCheckBox3';
    WebDBCheckBox3.Left := 240;
    WebDBCheckBox3.Top := 256;
    WebDBCheckBox3.Width := 137;
    WebDBCheckBox3.Height := 22;
    WebDBCheckBox3.Caption := 'Card Payment bank';
    WebDBCheckBox3.ChildOrder := 4;
    WebDBCheckBox3.HeightPercent := 100.000000000000000000;
    WebDBCheckBox3.WidthPercent := 100.000000000000000000;
    WebDBCheckBox3.DataField := 'bankcard';
    WebDBCheckBox3.DataSource := dsGLCodes;
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 232;
    WebDBEdit1.Top := 108;
    WebDBEdit1.Width := 169;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 5;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'GLCODE';
    WebDBEdit1.DataSource := dsGLCodes;
    WebDBEdit2.SetParentComponent(WebPanel1);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 232;
    WebDBEdit2.Top := 136;
    WebDBEdit2.Width := 281;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 6;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'GLDESCRIPTION';
    WebDBEdit2.DataSource := dsGLCodes;
    WebButton3.SetParentComponent(WebPanel1);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 407;
    WebButton3.Top := 107;
    WebButton3.Width := 25;
    WebButton3.Height := 25;
    WebButton3.Caption := '...';
    WebButton3.ChildOrder := 9;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 40;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'General Ledger Accounts';
    WebPanel2.ChildOrder := 10;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 6;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 334;
    WebPanel3.Width := 640;
    WebPanel3.Height := 48;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 11;
    WebPanel3.TabOrder := 7;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 13;
    WebButton1.Top := 10;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 129;
    WebButton2.Top := 10;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    wcGLCodes.SetParentComponent(Self);
    wcGLCodes.Name := 'wcGLCodes';
    wcGLCodes.Connection := dmData.dbConnect;
    wcGLCodes.Left := 32;
    wcGLCodes.Top := 56;
    wdsGLCodes.SetParentComponent(Self);
    wdsGLCodes.Name := 'wdsGLCodes';
    wdsGLCodes.Connection := dmData.dbConnect;
    wdsGLCodes.Left := 88;
    wdsGLCodes.Top := 56;
    wdsGLCodesGLCODE.SetParentComponent(wdsGLCodes);
    wdsGLCodesGLCODE.Name := 'wdsGLCodesGLCODE';
    wdsGLCodesGLCODE.FieldName := 'GLCODE';
    wdsGLCodesGLDESCRIPTION.SetParentComponent(wdsGLCodes);
    wdsGLCodesGLDESCRIPTION.Name := 'wdsGLCodesGLDESCRIPTION';
    wdsGLCodesGLDESCRIPTION.FieldName := 'GLDESCRIPTION';
    wdsGLCodesSUSPENDED.SetParentComponent(wdsGLCodes);
    wdsGLCodesSUSPENDED.Name := 'wdsGLCodesSUSPENDED';
    wdsGLCodesSUSPENDED.FieldName := 'SUSPENDED';
    wdsGLCodesbankaccount.SetParentComponent(wdsGLCodes);
    wdsGLCodesbankaccount.Name := 'wdsGLCodesbankaccount';
    wdsGLCodesbankaccount.FieldName := 'bankaccount';
    wdsGLCodesbankcard.SetParentComponent(wdsGLCodes);
    wdsGLCodesbankcard.Name := 'wdsGLCodesbankcard';
    wdsGLCodesbankcard.FieldName := 'bankcard';
    dsGLCodes.SetParentComponent(Self);
    dsGLCodes.Name := 'dsGLCodes';
    dsGLCodes.DataSet := wdsGLCodes;
    dsGLCodes.Left := 144;
    dsGLCodes.Top := 56;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    WebDBCheckBox2.AfterLoadDFMValues;
    WebDBCheckBox3.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    wcGLCodes.AfterLoadDFMValues;
    wdsGLCodes.AfterLoadDFMValues;
    wdsGLCodesGLCODE.AfterLoadDFMValues;
    wdsGLCodesGLDESCRIPTION.AfterLoadDFMValues;
    wdsGLCodesSUSPENDED.AfterLoadDFMValues;
    wdsGLCodesbankaccount.AfterLoadDFMValues;
    wdsGLCodesbankcard.AfterLoadDFMValues;
    dsGLCodes.AfterLoadDFMValues;
  end;
end;

end.